<template>
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
		stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
	</svg>
</template>

<script>
export default {
	name: "IconNoOper",
};
</script>
